module.exports = __webpack_public_path__ + "static/img/104293.3f94d115.png";